import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';

import ApIngestionContainer from '../../containers/apAutomation/ApIngestion';
import ResourceUploader from '../form/ResourceUploader';
import Button from '@material-ui/core/Button';
import Zoom from '@material-ui/core/Zoom';
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';
import Transition from './Transition';
import { DialogActions, Grid } from '@material-ui/core';
import FMPText from '../pureForm/FMPText';
import FormComponent from '../FormComponent';
import FMPSectionHeader from '../ui/FMPSectionHeader';
import FMPSubmitButton from '../form/FMPSubmitButton';
import { post } from '../../modules/utility';
import FMPRailcarAutocomplete from '../pureForm/FMPRailcarAutocomplete';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 50px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		width: '95%',
		maxWidth: '95%',
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	greenCheckedIcon: {
		display: 'inline-block',
		width: 33,
		height: 33,
		backgroundImage: `url('${GreenChecked}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
		marginLeft: 5,
	},
	isSaving: {
		marginLeft: 20,
		fontSize: 16,
		color: '#1565C0',
	},
	savingSuccessful: {
		marginLeft: 20,
		fontSize: 16,
		color: '#2E7D32',
	},
	stationDeliveryRow: {
		display: 'flex',
		lineHeight: '1.5',
		alignItems: 'flex-end',
	},
	deliveryLabel: {
		paddingRight: '4px',
		fontWeight: 500,
		color: '#222',
		fontSize: '85%',
		//letterSpacing: '.1em',
		textTransform: 'uppercase',
	},
	deliveryContainer: {
		padding: 10,
		border: '1px solid #ddd',
		borderRadius: '5px',
		backgroundColor: '#f7f7f7',
	},
});

class RailcarLinkageUpdateDialog extends FormComponent {
	constructor(props) {
		super(props);

		this.state = {
			formFieldError: {},
			isSaving: false,
			savingSuccessful: false,
			railcarId: undefined,
			linkedRailcarId: undefined,
		};
	}

	handleOnUpload = () => {
		this.setState({ isUploading: true });
	};
	handleDataFileUpload = ({ resource }) => {
		this.setState({ isUploading: false, bolResource: resource });
	};

	componentDidMount() {
		if (this.props.selectedRailcarToDeliveryMapId) {
			const { grossGallons, netGallons, bolResource, bol } = this.props.selectedDeliveryLeg || {};
			this.setState({
				bolResource,
				railcarId: this.props.selectedRailcarId,
				linkedRailcarId: this.props.linkedRailcarId,
				bol,
				grossGallons,
				netGallons,
			});
		}
	}

	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.open && prevProps.open !== this.props.open) {
			const { grossGallons, netGallons, bolResource, bol } = this.props.selectedDeliveryLeg || {};
			this.setState({
				bolResource,
				railcarId: this.props.selectedRailcarId,
				linkedRailcarId: this.props.selectedLinkedRailcarId,
				bol,
				grossGallons: grossGallons || '',
				netGallons,
			});
		}
	}

	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;
		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	getInputProps = (path) => {
		return {
			path,
			value: this.getValue(path),
			error: this.getError(path),
			onChange: this.onChange,
			checked: this.getValue(path, false),
			md: 12,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	handleClose = () => {
		this.setState({
			isSaving: false,
			savingSuccessful: false,
			bolResource: undefined,
		});
		this.props.onClose();
	};

	handleSave = () => {
		const { showErrors, selectedRailcarToDeliveryMapId, onAfterSave } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!_.get(this.state, path)) {
				formFieldError[path] = `${label} is required`;
			}
		});
		const { bol, railcarId, linkedRailcarId } = this.state;
		const net = this.state.netGallons;
		const gro = this.state.grossGallons;

		const netGallons = _.isString(net) ? parseInt(net.replace(/,/g, ''), 10) : net;
		if (!netGallons || _.isNaN(netGallons)) {
			formFieldError[`netGallons`] = `Net should be a number`;
		}

		let grossGallons = undefined;
		if (gro) {
			grossGallons = _.isString(gro) ? parseInt(gro.replace(/,/g, ''), 10) : gro;
			if (!grossGallons || _.isNaN(grossGallons)) {
				formFieldError[`grossGallons`] = `Gross should be a number`;
			}
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}
		const params = {
			railcarToDeliveryMapId: selectedRailcarToDeliveryMapId,
			bol,
			railcarId,
			linkedRailcarId,
			grossGallons,
			netGallons,
		};

		this.setState({
			isSaving: true,
		});

		post({
			method: 'railcarToDeliveryMap.update',
			params,
			callback: (err, apiSearchResult) => {
				console.log(apiSearchResult);
				if (err) {
					this.setState({
						isSaving: false,
					});
					return showErrors([err]);
				}

				_.delay(() => {
					this.setState({
						isSaving: false,
						savingSuccessful: true,
					});
					if (onAfterSave) {
						onAfterSave();
					}
				}, 500);
			},
		});
	};

	render() {
		const {
			classes,
			fullScreen,
			open,
			selectedStationDelivery,
			selectedBulkDeliveryId,
			railcarOptions,
			selectedTerminalId,
		} = this.props;
		const { isSaving, savingSuccessful, isUploading, bolResource } = this.state;

		const delivery = selectedStationDelivery;
		if (!delivery) {
			return (
				<Dialog
					fullScreen={fullScreen}
					maxWidth="md"
					open={open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
					classes={{ paper: classes.dialogPaper }}
				>
					<DialogTitle style={{ paddingBottom: 5 }}>Missing Delivery?</DialogTitle>
				</Dialog>
			);
		}

		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth="md"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle style={{ paddingBottom: 5 }}>Updated BOL Info</DialogTitle>
					<DialogContent>
						<Grid spacing={2} container>
							<Grid item xs={5}>
								<FMPSectionHeader label={selectedBulkDeliveryId ? 'Bulk Delivery:' : 'Delivery:'} isTop={true} />
								<div className={classes.deliveryContainer}>
									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>
											{selectedBulkDeliveryId ? 'Bulk Delivery Id:' : 'Delivery Id:'}
										</div>
										<div className={classes.deliveryValue}>
											{selectedBulkDeliveryId ? delivery.bulkDeliveryId : delivery.stationDeliveryId}
										</div>
									</div>

									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Customer:</div>
										<div className={classes.deliveryValue}>{delivery.customerDisplay}</div>
									</div>

									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Delivery Window:</div>
										<div className={classes.deliveryValue}>{delivery.deliveryDateFormatted}</div>
									</div>
									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Scheduled Gallons:</div>
										<div className={classes.deliveryValue}>{delivery.scheduledGallons}</div>
									</div>
									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Carrier:</div>
										<div className={classes.deliveryValue}>{delivery.carrierDisplay}</div>
									</div>

									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Loading #:</div>
										<div className={classes.deliveryValue}>{delivery.loadingNumber}</div>
									</div>
								</div>

								<Grid spacing={2} container>
									<Grid item xs={12}>
										<FMPSectionHeader label={'BOL Info:'} />
									</Grid>
									<FMPText {...this.setForm(`bol`, 'BOL #', true)} />
									<Grid item xs={12}>
										<FMPSectionHeader label={'Fuel Info:'} />
									</Grid>
									<Grid item xs={12}>
										<div
											style={{
												paddingLeft: 10,
												marginLeft: 10,
												borderLeft: '4px solid #eee',
												marginBottom: 20,
											}}
										>
											<div style={{ display: 'flex' }}>
												<Grid spacing={2} container>
													<FMPRailcarAutocomplete
														{...this.setForm(`railcarId`, 'Railcar', true, null)}
														terminalId={selectedTerminalId}
														railcarOptions={railcarOptions}
														md={6}
													/>
													<FMPRailcarAutocomplete
														{...this.setForm(`linkedRailcarId`, 'Linked Railcar', false, null)}
														terminalId={selectedTerminalId}
														railcarOptions={railcarOptions}
														md={6}
													/>
													<FMPText {...this.setForm(`netGallons`, 'Net Gallons')} />
													<FMPText {...this.setForm(`grossGallons`, 'Gross Gallons')} />
												</Grid>
											</div>
										</div>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={7}>
								{bolResource ? (
									<div className={classes.pageImage}>
										<object
											data={bolResource.url}
											style={{ height: '800px', width: '100%', maxWidth: '100%' }}
											type="application/pdf"
										>
											<a href={bolResource.url}>bol.pdf</a>
										</object>
									</div>
								) : (
									<ResourceUploader
										name={'bolResourceId'}
										label={''}
										onUpload={this.handleOnUpload}
										afterUpload={this.handleDataFileUpload}
									/>
								)}
								<div>
									Note: To delete the BOL, go back to the master sheet and delete and then reupload
								</div>

								{isUploading && (
									<Zoom
										in={isSaving}
										style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
										mountOnEnter
										unmountOnExit
									>
										<div className={classes.isSaving}>
											<CircularProgress style={{ verticalAlign: 'middle' }} />
											<span style={{ paddingLeft: 10 }}>Saving...</span>
										</div>
									</Zoom>
								)}
							</Grid>
						</Grid>
					</DialogContent>

					<DialogActions>
						<Button onClick={this.handleClose}>Close</Button>

						<FMPSubmitButton
							onClick={this.handleSave}
							buttonText={'Update BOL Info'}
							isDisabled={isSaving}
						/>
					</DialogActions>

					<div style={{ display: 'flex', alignItems: 'baseline' }}>
						<Zoom
							in={isSaving}
							style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom
							in={savingSuccessful}
							style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
						>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>
									Save successful. Hit the close button or the escape key.
								</span>
							</div>
						</Zoom>
					</div>
				</div>
			</Dialog>
		);
	}
}

RailcarLinkageUpdateDialog.propTypes = {
	selectedRailcarToDeliveryMapId: PropTypes.number,
	selectedStationDelivery: PropTypes.object,
	selectedBulkDeliveryId: PropTypes.number,
	selectedDeliveryLeg: PropTypes.object,
	selectedStationId: PropTypes.number,
	selectedTankNumber: PropTypes.number,
	selectedRailcarId: PropTypes.number,
	selectedLinkedRailcarId: PropTypes.number,
	selectedTerminalId: PropTypes.number,
	onAfterSave: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	fullScreen: PropTypes.bool.isRequired,
	railcarOptions: PropTypes.array,
	showErrors: PropTypes.func,
};

export default _.flow([withStyles(styles), withMobileDialog(), ApIngestionContainer])(
	RailcarLinkageUpdateDialog
);
